document.addEventListener('DOMContentLoaded' , () =>{
	//category-lists-page
	const categoryToggleBtn = document.querySelectorAll('.js_category_toggleBtn');

	if(document.querySelector('.category-lists-page')){
		categoryToggleBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				if(el.classList.contains('active')){
					el.classList.remove('active');
				}else{
					el.classList.toggle('active');
				}
			});
		})
	}

	//main-page
	const subCateBtn = document.querySelectorAll('.sub-category__menu .sub-category__list');
	
	if(subCateBtn){
		subCateBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				subCateBtn.forEach(function(el){
					el.classList.remove('active');
				});
				el.classList.add('active');
			});
		})
	}
	
	if(document.querySelector('.main-page')){
        $('.main-visual').slick({
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
			autoplay:true,
			autoplaySpeed:3000,
            speed:1300,
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$(".main-visual__control .current").html(nextSlide + 1);
		});   

		$(".main-visual__control .total").html($(".main-visual .main-visual__slide").length - 2);

        $('.notice-area__slide').slick({
            dots:false,
            arrows:false,
			autoplay:true,
			autoplaySpeed:5000,
		});
	}
});
